/*
 * The admin site's words in Danish: the shell - line for line shell.en.ts.
 */

import type { shellEn } from './shell.en.js';

export const shellDa: typeof shellEn = {
  sidebar: {
    label: 'Administrationens afsnit',
    overview: 'Oversigt',
    articles: 'Artikler',
    releaseNotes: 'Udgivelsesnoter',
    attachments: 'Vedhæftede filer',
    promoted: 'Fremhævede',
    metadata: 'Metadata',
    settings: 'Indstillinger',
  },

  overview: {
    loading: 'Indlæser oversigten…',
    title: 'Oversigt',
    intro: 'Vidensbasens tilstand lige nu.',
    newArticle: 'Ny artikel',
    articles: 'Artikler',
    live: 'Live',
    scheduled: 'Planlagt',
    hidden: 'Skjult',
    needsAttention: 'Kræver opmærksomhed',
    unpublishedDrafts: 'Ikke-udgivne kladder',
    unpublishedDraftsHint: 'Der findes en nyere revision end den, læserne får.',
    withdrawn: 'Tekst trukket tilbage',
    withdrawnHint:
      'Der findes revisioner, men ingen er gældende: den udgivne tekst er trukket tilbage, og der vises intet, før en af dem gøres gældende.',
    unwritten: 'Endnu ikke skrevet',
    unwrittenHint: 'Artiklen findes, men har ingen revision overhovedet, så der er intet at vise.',
    untagged: 'Artikler uden kategori',
    untaggedHint:
      'Mangler en kategori. Produktet er en kolonne på artiklen, så den halvdel mangler aldrig.',
    recentlyEdited: 'Senest redigeret',
    nothingEdited: 'Intet er redigeret endnu.',
    nextScheduled: 'Næste planlagte',
    goesLive: 'Går live {date}',
    nothingScheduled: 'Intet er planlagt.',
    metadata: 'Metadata',
    tagCounts: (products, categories) =>
      `${products} ${products === 1 ? 'produkt' : 'produkter'} · ${categories} ${categories === 1 ? 'kategori' : 'kategorier'}`,
    manageMetadata: 'Administrer metadata',
  },
};
